import moment from 'moment';
import {
  allIsFalse,
  DEFAULT_VALID,
  DEFAULT_VALIDATION_MODEL,
  firstDateIsBefore,
  firstHourIsBefore,
  requiredIsValid,
  validaData,
  validaHora,
} from 'helpers/utils/ValidationUtils';

export interface ValidatorProps {
  allIsValid: () => {
    error: boolean;
    helperText: string;
  };
  tituloIsValid: () => {
    error: boolean;
    helperText: string;
  };
  dataInicioIsValid: () => {
    error: boolean;
    helperText: string;
  };
  dataFimIsValid: () => {
    error: boolean;
    helperText: string;
  };
  horaInicioIsValid: () => {
    error: boolean;
    helperText: string;
  };
  horaFimIsValid: () => {
    error: boolean;
    helperText: string;
  };
}

export const EditarEventoModalValidator = (
  titulo: any,
  dataInicio: any,
  dataFim: any,
  horaInicio: any,
  horaFim: any
) => {
  const validator: any = {};

  validator.tituloIsValid = () => {
    const value = titulo;
    const required = requiredIsValid(value, `Título é obrigatório`);
    if (required.error) {
      return required;
    }
    return DEFAULT_VALID;
  };

  validator.dataInicioIsValid = () => {
    const required = requiredIsValid(
      dataInicio,
      'Data do evento é obrigatória'
    );

    const date = moment(dataInicio, 'DD/MM/yyyy').format('yyyy-MM-DD');
    const GivenDate = new Date(date);
    const CurrentDate = new Date();

    if (required.error) {
      return required;
    }
    const isValid = validaData(dataInicio);
    if (!isValid) {
      return DEFAULT_VALIDATION_MODEL(true, 'Data inválida');
    }
    if (firstDateIsBefore(dataFim, dataInicio)) {
      return DEFAULT_VALIDATION_MODEL(
        true,
        'Data deve ser anterior à data de encerramento'
      );
    }

    if (GivenDate > CurrentDate) {
      return DEFAULT_VALIDATION_MODEL(
        true,
        'Evento deve ser anterior à data atual'
      );
    }
    return DEFAULT_VALID;
  };

  validator.dataFimIsValid = () => {
    const required = requiredIsValid(
      dataFim,
      'Data de encerramento é obrigatória'
    );

    const date = moment(dataFim, 'DD/MM/yyyy').format('yyyy-MM-DD');
    const GivenDate = new Date(date);
    const CurrentDate = new Date();

    if (required.error) {
      return required;
    }
    const isValid = validaData(dataFim);
    if (!isValid) {
      return DEFAULT_VALIDATION_MODEL(true, 'Data inválida');
    }
    if (firstDateIsBefore(dataFim, dataInicio)) {
      return DEFAULT_VALIDATION_MODEL(
        true,
        'Data deve ser posterior à data do evento'
      );
    }

    if (GivenDate > CurrentDate) {
      return DEFAULT_VALIDATION_MODEL(
        true,
        'Encerramento deve ser anterior à data atual'
      );
    }

    return DEFAULT_VALID;
  };

  validator.horaInicioIsValid = () => {
    const required = requiredIsValid(
      horaInicio,
      'Hora de início é obrigatória'
    );
    if (required.error) {
      return required;
    }
    const isValid = validaHora(horaInicio);
    if (!isValid) {
      return DEFAULT_VALIDATION_MODEL(true, 'Hora inválida');
    }
    if (dataFim === dataInicio && firstHourIsBefore(horaFim, horaInicio)) {
      return DEFAULT_VALIDATION_MODEL(
        true,
        'Deve ser anterior à hora de encerramento'
      );
    }
    return DEFAULT_VALID;
  };

  validator.horaFimIsValid = () => {
    const required = requiredIsValid(
      horaFim,
      'Hora de encerramento é obrigatória'
    );
    if (required.error) {
      return required;
    }
    const isValid = validaHora(horaFim);
    if (!isValid) {
      return DEFAULT_VALIDATION_MODEL(true, 'Hora inválida');
    }
    if (dataFim === dataInicio && firstHourIsBefore(horaFim, horaInicio)) {
      return DEFAULT_VALIDATION_MODEL(
        true,
        'Deve ser posterior à hora do evento'
      );
    }
    return DEFAULT_VALID;
  };

  validator.allIsValid = () => {
    return allIsFalse([
      validator.tituloIsValid().error,
      validator.dataInicioIsValid().error,
      validator.dataFimIsValid().error,
      validator.horaInicioIsValid().error,
      validator.horaFimIsValid().error,
    ]);
  };

  return validator;
};
